<template>
	<div id="app">
		<Accessibility />
		<NavBar />
		<main tabindex="-1" role="main">
			<Hero />
			<Impact />
			<Social />
			<Video />
			<Manulife />
			<Foot />
		</main>
	</div>
</template>

<script>
import Accessibility from './components/partials/Accessibility.vue'
import NavBar from './components/layout/NavBar.vue'
import Hero from './components/sections/Hero.vue'
import Impact from './components/sections/Impact.vue'
import Social from './components/sections/Social.vue'
import Video from './components/sections/Video.vue'
import Manulife from './components/sections/Manulife.vue'
import Foot from './components/layout/Foot.vue'

export default {
	name: 'App',
	components: {
		Accessibility,
		NavBar,
		Hero,
		Impact,
		Social,
		Video,
		Manulife,
		Foot,
	},
	mounted() {
		var event = new Event('pageLoad')
		document.dispatchEvent(event)
	},
	created() {
		var frKeys = ['/fr', '.fr.', 'labanquealimentairevousaide']

		this.$i18n.locale = 'en'

		for (let i in frKeys) {
			if (window.location.href.includes(frKeys[i])) {
				this.$i18n.locale = 'fr'
			}
		}
	},
	metaInfo() {
		return {
			title: this.$t('Common.page.title'),
		}
	},
}
</script>

<style lang="scss">
//
</style>
